import React from 'react'

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import "swiper/css/navigation";
import { Navigation } from "swiper";
import Image1 from '../../../img/shape-wawes.svg'
import {TestimonialData} from './Data'
import './testimonial.css'


const Testimonial = () => {
    return (
    <>
        <section className="testimonial section" id="testimonial">
                <h2 className="section__title">اراء العملاء</h2>
                <span className="section__subtitle">تعليقات العملاء</span>

                <div className="container section__border">

                    <Swiper grabCursor={true} navigation={{
                            prevEl: '.swiper-button-prev',
                            nextEl: '.swiper-button-next',
                        }}
                        modules={[Navigation]} className="testimonial__container">
                        {/* <!--==================== TESTIMONIAL Number ====================--> */}
                        
                        {
                            TestimonialData.map((item,index)=>{
                                return(
                                    <SwiperSlide className="testimonial__content" key={index}>
                                        <p className="testimonial__description">
                                            {item.TextClinet}
                                        </p>

                                        <div>
                                            <h3 className="testimonial__name">{item.NameClinet}</h3>
                                            <span className="testimonial__subtitle">{item.Clinet}</span>
                                        </div>
                                    </SwiperSlide>
                                )
                            })
                        }

                        {/* <!-- Swiper Arrows --> */}
                        <div className='swiper-button-next'>
                            <i className="ri-arrow-left-s-line"></i>
                        </div>
                        <div className='swiper-button-prev'>
                            <i className="ri-arrow-right-s-line"></i>
                        </div>
                        
                    </Swiper>
                    
                </div>
                <img className="testimonial__img" src={Image1} alt="testimonial"/>
        </section>
    </>
    )
}

export default Testimonial